module.exports = __webpack_public_path__ + "img/methods (5).a7aa7593.png";